import { render, staticRenderFns } from "./FooterHome.vue?vue&type=template&id=f20688ac&scoped=true"
import script from "./FooterHome.vue?vue&type=script&lang=js"
export * from "./FooterHome.vue?vue&type=script&lang=js"
import style0 from "./FooterHome.vue?vue&type=style&index=0&id=f20688ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20688ac",
  null
  
)

export default component.exports